import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePicService = new CrudCustom('/tipe-pics');
export default TipePicService;
